export default "__VITE_ASSET__DXNnJlLh__"